import Cookies from 'js-cookie'
import A11yDialog from 'a11y-dialog'

const element = document.getElementById('dialog-overlay')
if (element) {

    if (element.dataset.cookieModal === 'setcookie') {
        Cookies.set('seenautomodal', true, {
            expires: 1,
        })
    }

    const dialog = new A11yDialog(element)

    dialog
    .on('show', () => (document.documentElement.style.overflowY = 'hidden'))
    .on('hide', () => (document.documentElement.style.overflowY = ''))

    dialog.show()

}
